import { Injectable } from '@angular/core';

import { Observable, fromEvent } from 'rxjs';
import { auditTime, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BrowserProviderService {

    ScrollPosition: Observable<number>;

    constructor() {
        this.ScrollPosition = fromEvent(document, 'scroll').pipe(
                map(_ev => window.scrollY),
                auditTime(250));
    }

    GetLocation(): Location {
        return window.location;
    }

    createObjectURL(blob: Blob): string {
        return window.URL.createObjectURL(blob);
    }

    revokeObjectURL(url: string): void {
        window.URL.revokeObjectURL(url);
    }

    open(url: string, windowName: string, windowFeatures?: string): Window {
        return window.open(url, windowName, windowFeatures);
    }

    get scrollHeight(): number {
        return document.body.scrollHeight;
    }

    get innerHeight(): number {
        return window.innerHeight;
    }

    get console(): Console {
        return console;
    }

    get location(): Location {
        return window.location;
    }

    get localStorage(): Storage {
        return window.localStorage;
    }

    get history(): History {
        return window.history;
    }

    get window(): Window {
        return window;
    }
}
